import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
export var pushPopoverWithOptions = createAction("".concat(actionPrefix, ".PUSH_POPOVER"), function (id, options) {
    return {
        id: id,
        options: options,
    };
});
export var pushPopover = function (id, options) {
    if (options === void 0) { options = {}; }
    return pushPopoverWithOptions(id, options);
};
export var removePopover = createAction("".concat(actionPrefix, ".REMOVE_POPOVER"), function (id) { return id; });
//# sourceMappingURL=actionCreators.js.map